import { type Component } from "solid-js"
import coerceToColorIntegerOrNull from "../../lib/core/player/coerceToColorIntegerOrNull"
import type { PlayerColor } from "../../lib/core/player/PlayerColor.type"
import type { PlayerColorKey } from "../../lib/core/player/PlayerColorKey.type"
import playerColorToHex from "../../lib/core/player/playerColorToHex"
import isNotNil from "../../lib/ldsh/isNotNil"

interface PlayerColorPickerProps {
  id?: string
  class: string
  value: PlayerColor
  onChange?: (color: PlayerColor) => void
  onInput?: (color: PlayerColor) => void
  key: PlayerColorKey
}

const colorKeyDisplayNames: Record<PlayerColorPickerProps['key'], string> = {
  color1: 'Primary',
  color2: 'Secondary',
}

type ColorEvent = Event & {
  currentTarget: HTMLInputElement
  target: HTMLInputElement
}

type NewColorFn = (val: PlayerColor) => void

export const PlayerColorPicker: Component<PlayerColorPickerProps> = (props) => {
  function propagateOrNot(fn: NewColorFn | undefined) {
    return (fn && ((val: ColorEvent) => {
      const color = coerceToColorIntegerOrNull((val.target as HTMLInputElement).value)
      if (isNotNil(color)) {
        fn(color)
      }
    }))
  }

  return (
    <input
      id={props.id}
      class={props.class}
      name={props.key}
      value={playerColorToHex(props.value)}
      type="color"
      onChange={
        // eslint-disable-next-line solid/reactivity
        propagateOrNot(props.onChange)}
      onInput={
        // eslint-disable-next-line solid/reactivity
        propagateOrNot(props.onInput)}
      placeholder={`${colorKeyDisplayNames[props.key]} Player Color`}
    />
  )
}
